import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class FileUploadService {
  // Observable string sources
  private fileuploadSource = new Subject<any>();
  private checkValidSource = new BehaviorSubject<string>('Not Import button Active');
  private sheetToJsonDataSource = new BehaviorSubject([]);

  // Observable string streams
  public fileuploadDataobservable$ = this.fileuploadSource.asObservable();
  public checkValidDataobservable$ = this.checkValidSource.asObservable();
  public sheetToJsonDataobservable$ = this.sheetToJsonDataSource.asObservable();

  // Service message commands
  public sendFileUploadedData(d: any): void {
    this.fileuploadSource.next(d);
  }

  public sendIfValidData(d: any): void {
    this.checkValidSource.next(d);
    console.log("dd",d);
    
  }

  public getSheetToJSONData(d: any): void {
   this.sheetToJsonDataSource.next(d);
  }
}
